// Central table of the eight ParSetgnostics metrics: database column, optimization direction, and value range.
// Everything that needs a direction (optimizers, ground-truth tables, tests) reads it here. One metric version,
// 'corrected'; the 2021 (legacy) version was removed in todo/11, the option `version` keeps this one value.
//
// group:     'category'  = category ordering-dependent (also changes with the attribute order)
//            'attribute' = attribute ordering-dependent (invariant under category reordering)
// direction: 'min' or 'max' = which values are better
// column:    result field / database column holding the metric
// range:     [lower, upper] bound of valid values (null = no fixed bound)

export const VERSIONS = ['corrected'];

export const METRICS = {
    overlap: {
        label: 'Overlap', group: 'category', direction: 'min',
        corrected: { column: 'overlap', range: [0, null] },
    },
    slope: {
        label: 'Slope', group: 'category', direction: 'min',
        corrected: { column: 'slope', range: [0, 90] },
    },
    orthogonality: {
        label: 'Orthogonality', group: 'category', direction: 'min',
        corrected: { column: 'orthogonality', range: [0, 1] },
    },
    // Crossing pairs per ribbon.
    crossings: {
        label: 'Number of Crossings', group: 'category', direction: 'min',
        corrected: { column: 'crossings', range: [0, null] },
    },
    // Mean acute crossing angle in degrees, 90 if nothing crosses.
    crossingAngle: {
        label: 'Crossing Angle', group: 'category', direction: 'max',
        corrected: { column: 'crossingAngle', range: [0, 90] },
    },
    numRibbons: {
        label: 'Number of Ribbons', group: 'attribute', direction: 'min',
        corrected: { column: 'relNumRibbons', range: [0, 1] },
    },
    // Population standard deviation.
    widthVariance: {
        label: 'Ribbon Width Variance', group: 'attribute', direction: 'min',
        corrected: { column: 'widthSd', range: [0, 0.5] },
    },
    mutualInfo: {
        label: 'Mutual Information', group: 'attribute', direction: 'max',
        corrected: { column: 'mutualInfo', range: [0, null] },
    },
};

export const METRIC_NAMES = Object.keys(METRICS);

export function metricColumn(metric, version = 'corrected') {
    return METRICS[metric][version].column;
}

// True if value a is better than value b for the metric.
export function isBetter(metric, a, b) {
    return METRICS[metric].direction === 'min' ? a < b : a > b;
}
